import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all organisations
export const getOrganisations = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/organisations`);
    return response.data;
  } catch (error) {
    console.error("Error fetching organisations:", error.response?.data || error);
    throw error;
  }
};

// GET a single organisation
export const getOrganisationById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/organisations/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching organisation:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new organisation
export const createOrganisation = async (organisationData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/organisations`, organisationData);
    return response.data;
  } catch (error) {
    console.error("Error creating organisation:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing organisation
export const updateOrganisation = async (id, organisationData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/organisations/${id}`, organisationData);
    return response.data;
  } catch (error) {
    console.error("Error updating organisation:", error.response?.data || error);
    throw error;
  }
};

// DELETE a organisation
export const deleteOrganisation = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/organisations/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting organisation:", error.response?.data || error);
    throw error;
  }
};
